export default __webpack_public_path__ + "35d715637c2ff1edc6e1610463a38c2a.png";